import Button from "@mui/material/Button";

import { useAuth } from "~auth/useAuth";
import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";

export function SignOutButton() {
  const { logout } = useAuth();
  const t = useTranslation();

  return (
    <Button variant="outlined" onClick={logout}>
      {t.signOut}
    </Button>
  );
}
